import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="reports--preview"
//
// The docked report preview shows one row by default so it does not eat the
// viewport, and expands to the handful of rows the generator returned. The
// choice lasts for the page view only, because it depends on what the user is
// doing rather than on who they are.
export default class extends Controller {
  static targets = ["toggle"]

  connect() {
    // Delegated, so a tooltip arriving with a turbo stream works without
    // being initialised again. turbo:load does not fire for a stream, which
    // is what the global initialiser in legacy.js listens for.
    $(this.element).tooltip({ selector: '[data-toggle="tooltip"]' });
  }

  disconnect() {
    $(this.element).tooltip("dispose");
  }

  // A turbo stream replaces the table and its heading whenever a field
  // changes, so the button arrives with the server's default label while the
  // panel may already be expanded. This controller's element sits outside
  // that region and does not reconnect, so the label is set here instead.
  toggleTargetConnected() {
    this.#renderLabel();
  }

  toggle() {
    this.element.classList.toggle("is-compact");
    this.#renderLabel();
  }

  #renderLabel() {
    this.toggleTarget.textContent =
      this.element.classList.contains("is-compact")
        ? "Show more rows"
        : "Show fewer rows";
  }
}
